import { createSelector } from "reselect";
import { getSections } from "./getSections";
import { Availability, Section } from "../types";

export const getOfflineSectionDisplayNames = createSelector(getSections, (sections) =>
    sections.filter((s: Section) => s.availability !== Availability.NOW).map((s) => s.displayName)
);
